import PageToolBase from './page_tool';
import { focusStore } from '../store/nowFocusStore';
import { store } from '../../store';
import { windowContentScaleX, windowContentScaleY } from '../common/content_scale';
import { distanceBetweenPoints } from '../common/distance';
export default class PageMove extends PageToolBase {
    bookPage = null;
    startMove = false;
    moveDelta = { x: 0, y: 0 };
    canvasScale = { x: 1, y: 1 };
    mousedownOnPage = false;
    constructor(bookPage) {
        super();
        this.bookPage = bookPage;
    }
    onPointerDown(e) {
        if (this.bookPage.containerScale == 1) return;
        this.bookPage.pageLoader.startMoveContainer(0);

        if (this.bookPage.canvasContainer) {
            this.canvasScale.x = this.bookPage.canvasContainer.dataset.scaleX || 1;
            this.canvasScale.y = this.bookPage.canvasContainer.dataset.scaleY || 1;
        } else {
            this.canvasScale = { x: 1, y: 1 };
        }


        this.startMove = false;
        this.mousedownOnPage = true;
        this.moveDelta.x = e.clientX - store.globalPaintData.margin;
        this.moveDelta.y = e.clientY;
    }
    onPointerMove(e) {
        if (this.mousedownOnPage && !this.startMove) {
            const cursorPoint = {
                x: Math.round(e.clientX - store.globalPaintData.margin),
                y: Math.round(e.clientY)
            }
            const distance = distanceBetweenPoints(cursorPoint, this.moveDelta);
            if (distance > 9) {
                this.startMove = true;
            }

            return;
        }
        if (!this.startMove) return;
        if (focusStore.getSelectedObject()) return;
        let point = {
            x: Math.round(e.clientX - store.globalPaintData.margin - this.moveDelta.x),
            y: Math.round(e.clientY - this.moveDelta.y)
        };

        let x = parseInt(this.bookPage.svgScaler.style.left.split('px')[0]) || 0;
        let y = parseInt(this.bookPage.svgScaler.style.top.split('px')[0]) || 0;
        let fixedPoint = this.bookPage.fitBorder((x + point.x), (y + point.y));
        this.bookPage.move(fixedPoint.x, fixedPoint.y);
        this.bookPage.pageLoader.setStagePosition(fixedPoint);


        this.bookPage.scalePaintAndMove(this.containerScale, fixedPoint.x / this.canvasScale.x, fixedPoint.y / this.canvasScale.y);

        if (this.bookPage.containerPosition) {
            this.bookPage.containerPosition.x = fixedPoint.x;
            this.bookPage.containerPosition.y = fixedPoint.y;
        }

        this.moveDelta = {
            x: e.clientX - store.globalPaintData.margin,
            y: e.clientY
        };

    }
    onPointerUp(e) {
        let svgContainerBoundingRect = this.bookPage.svgContainer.getBoundingClientRect();
        let pageContainerBoundingRect = this.bookPage.$refs.page_container.getBoundingClientRect();
        let x = parseInt(this.bookPage.svgScaler.style.left.split('px')[0]) || 0;
        let y = parseInt(this.bookPage.svgScaler.style.top.split('px')[0]) || 0;

        let px = (pageContainerBoundingRect.width * 0.5 - (x * windowContentScaleX.value * store.currentBookPageScale.x)) / svgContainerBoundingRect.width;
        let py = (pageContainerBoundingRect.height * 0.5 - (y * windowContentScaleY.value * store.currentBookPageScale.y)) / svgContainerBoundingRect.height;

        this.bookPage.pagePercentPoint.x = px;
        this.bookPage.pagePercentPoint.y = py;

        this.startMove = false;
        this.mousedownOnPage = false;
    }
}